import { useMemo } from 'react';
import debounce from 'lodash/fp/debounce';

import useBatchData from 'pages/Batch/sections/Context/useBatchData';

const useDoProcess = () => {
  const { process } = useBatchData();

  const doProcess = useMemo(() => debounce(200, process), [process]);
  return doProcess;
};

export default useDoProcess;
